import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { BuildOutlined } from '@mui/icons-material';
import { usePMDetailsEditor } from '../../../../hooks/usePMDetailsEditor';
import { EditorMode } from '../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const PMPartsUsedEditor: React.FC<Props> = ({ mode }) => {
  const { pmDetails, updatePMField } = usePMDetailsEditor(mode);

  const handleChange = (value: string) => {
    updatePMField({ partsUsed: value });
  };

  return (
    <TextField
      label="Parts Used"
      value={pmDetails?.partsUsed || ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      multiline
      minRows={2}
      maxRows={4}
      placeholder="List parts used during maintenance"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <BuildOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default PMPartsUsedEditor;
